import { ACCOUNTING_CA, ACCOUNTING_CATEGORIES, docTypeOf, type IPack, type IPackDocType } from '../packs/index.js';

/**
 * The accounting pack's vocabulary, kept under its original names for existing code. Document
 * types now live in packs (web/api/src/packs): pass a pack to look up another pack's types.
 */
export const CATEGORIES = ACCOUNTING_CATEGORIES;

export type Category = string;

export type IDocType = IPackDocType;

export const DOC_TYPES: IDocType[] = ACCOUNTING_CA.docTypes;

export function docTypeById(id: string | undefined, pack: IPack = ACCOUNTING_CA): IDocType | undefined {
  return docTypeOf(pack, id);
}
